function isFullLocation(location) {
    return location.address !== undefined;
}
function joinAddressLine2(parts) {
    const cityState = [parts.city, parts.state].filter(Boolean).join(', ');
    return [cityState, parts.zip].filter(Boolean).join(' ');
}
export default function buildSelectedLocation(location) {
    if (isFullLocation(location)) {
        return {
            name: location.name,
            addressLine1: [location.address.street1, location.address.street2]
                .filter(Boolean)
                .join(' '),
            addressLine2: joinAddressLine2(location.address),
            phone: location.phone,
        };
    }
    return {
        name: location.name ?? '',
        addressLine1: [location.street1, location.street2]
            .filter(Boolean)
            .join(' '),
        addressLine2: joinAddressLine2(location),
        phone: location.phone ?? '',
    };
}
